<template>
  <div id="app">
    <div class="body_bg">
      <div class="container whitebg pd15">
        <el-row :gutter="25">
          <Mlogin />
          <el-col :xs="24" :sm="24" :md="19" :lg="19" :xl="19" class="main-content">
            <div class="grid-content bg-purple-light">
              <div class="side_con">
                <div class="side_container">
                  <div class="title_all" style="margin-bottom: 0">
                    <div class="title_left">Archive</div>
                    <div class="title_more2">
                      <a href="/EN">Home</a>>Archive
                    </div>
                    <div class="clearfix"></div>
                  </div>
                  <dlistnumList></dlistnumList>
                </div>
              </div>
            </div>
          </el-col>
          <DocumentsNewsBlockControl />
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import dlistnumList from '../components/dlistnumList'
export default {
  data() {
    return {}
  },
  components: {
    dlistnumList,
  },
  methods: {
    onSubmit() { },
  },
}
</script>

<style scoped></style>
